import React, { Component } from "react";
import { observer } from "mobx-react";
import { Accessor, ColorX, GFunc, LocaleX, ReqX } from "IZOX/STATIC";
// eslint-disable-next-line no-unused-vars
import PropsType from "prop-types";
import { HStack, Spacer, VStack, XButton, XText } from "IZOX/_X";
import NewClaim from "./_gears/NewClaim";
import { PageFlipper } from "IZOX/BLOCKS/Libs";
import _ from "lodash";
import QUICKUI from "shared/QUICKUI";
import ClaimRow from "shared/ClaimRow";
import ViewClaim from "./_gears/ViewClaim";
import PDCContainer from "../shared/PDCContainer/PDCContainer";

/**
 * @augments {Component<Props, State>}
 */
class PDCClaimsW extends Component {

  static propTypes = {

  }

  static defaultProps = {

  }

  constructor(){
    super();
    this.state = {
      docs: [],
      selected: [],
      tab: "All",
      page: 0,
      pageSize: 5
    };
  }

  componentDidMount(){
    this._setAllStates(() => {
      this.GetClaims();
    });
  }

  componentDidUpdate(prevProps, prevState){
    if(!Accessor.IsIdentical(prevProps, this.props, Object.keys(PDCClaimsW.defaultProps))){
      this._setAllStates();
    }
  }

  componentWillUnmount() {
    this.setState = (state, callback) => {
      return;
    };
  }

  _setAllStates = (callback) => {
    this.setState((state, props) => ({
      ...props,
    }), callback);
  }

  GetClaims = async () => {
    let {page, pageSize, tab} = this.state;
    let res = await ReqX.SendBE("/Web/DCustomer/GetClaims", {
      status: tab === "All"? undefined : tab,
      page,
      pageSize
    });
    let {Success, payload} = res;
    if(Success){
      let {docs, count} = payload;
      this.setState({
        docs, count
      });
    }
  }

  _onPageSizeChange = (pageSize) => {
    this.setState({
      pageSize: pageSize
    }, () => {
      this.GetClaims();
    });
  }

  _onPageChange = (page) => {
    this.setState({
      page: page
    }, () => {
      this.GetClaims();
    });
  }

  _toNewClaim = () => {
    GFunc.Backdrop(() => {
      return (
        <NewClaim Refresh={this.GetClaims}/>
      );
    }, {}, false);
  }

  _toTab = (tab) => {
    this.setState({
      tab: tab,
      page: 0
    }, () => {
      this.GetClaims();
    });
  }

  PopupClaim = async (docID) => {
    let res = await ReqX.SendBE("/Web/DCustomer/ViewClaim", {
      docID
    });
    let {Success, payload} = res;
    if(Success){
      GFunc.Backdrop(() => {
        return (
          <ViewClaim doc={payload}/>
        );
      }, {}, false);
    }else{
      GFunc.Alert(payload, "error");
    }
  }

  renderClaimDoc(doc, idx){
    return (
      <ClaimRow claimDoc={doc} key={idx} onViewDetailPress={() => this.PopupClaim(doc._id)}/>
    );
  }

  renderHeader(){
    return (
      <HStack mB={24}>
        <XText bold color={ColorX.CSS("Leaf")} fontSize={16}>
          {LocaleX.Parse({
            EN: "Claims",
            TC: "理賠"
          })}
        </XText>
        <Spacer/>
        <XButton onPress={this._toNewClaim} pH={30} round={50}
            bgColor={ColorX.CSS("Axit")}
            color={ColorX.CSS("pureWhite")}
            padding={6}>
          <HStack>
            <XText bold fontSize={14}>
              {LocaleX.Parse({
                EN: "Add new claim",
                TC: "新增索償"
              })}
            </XText>
          </HStack>
        </XButton>
      </HStack>
    );
  }

  renderTabBtn(_tab, text, extraStyle, idx){
    let {tab} = this.state;
    let isTab = tab === _tab;
    return (
      <XButton color={ColorX.CSS(isTab? "pureWhite" : "Gray4")}
        bgColor={ColorX.CSS(isTab ? "Axit" : "pureWhite")}
        fitWidthToContent zIndex={isTab ? 15 : 10 - idx}
        mL={idx === 0 ? 0 : -10} mT={10}
        padding={10} pH={15}
        onPress={() => this._toTab(_tab)}
        style={{
          ...extraStyle,
          minWidth: 150,
          borderRadius: "10px 10px 0px 0px",
          boxShadow: `0px 2px 2px 2px ${ColorX.CSS("greyOut", 0.5)}`
        }}>
        <HStack>
          <XText fontSize={14}>
            {LocaleX.Parse(text)}
          </XText>
        </HStack>
      </XButton>
    );
  }

  renderClaimTabs(){
    return (
      <HStack HAlign="[">
        {this.renderTabBtn("All", {EN: "All", TC: "全部"}, {}, 0)}
        {this.renderTabBtn("Submitted", {EN: "Submitted", TC: "已提交"}, {}, 1)}
        {this.renderTabBtn("Approved", {EN: "Approved", TC: "已核准"}, {}, 2)}
        {this.renderTabBtn("Declined", {EN: "Declined", TC: "已拒絕"}, {}, 3)}
        {this.renderTabBtn("Completed", {EN: "Completed", TC: "已完成"}, {}, 4)}
      </HStack>
    );
  }

  renderClaimList(){
    let {docs, page, pageSize, count} = this.state;
    if(docs.length === 0){
      return QUICKUI.NoDocs({
        EN: "There is no claims.",
        TC: "沒有任何索償紀錄。"
      });
    }
    return (
      <VStack fullWidth>
        {_.map(docs, (o, i) => {
          return this.renderClaimDoc(o, i);
        })}
        <PageFlipper totalDocs={count} 
          page={page}
          pageSize={pageSize}
          onPageSizeChange={this._onPageSizeChange}
          onPageChange={this._onPageChange}
          popupPosition="top" 
          mainColor={ColorX.CSS("Axit")} />
      </VStack>
    );
  }

  render(){
    return (
      <PDCContainer>
        <VStack bgColor={ColorX.CSS("NotQuiteWhite")} fullWidth
          p={16}>
            {this.renderHeader()}
            {this.renderClaimTabs()}
            {this.renderClaimList()}
        </VStack>
      </PDCContainer>
    );
  }

}

export default observer(PDCClaimsW);
